import { ICartItem } from "@/services/api/CartItem/type";
import cartApi from "../../../services/api/Cart";
import cartItemApi from "../../../services/api/CartItem";
import { CURRENT_SUBDOMAIN, DEMANDORIA_SUBDOMAINS } from "@/utils/stringUtils";
import { TFunction } from "i18next";
import orderApi from "@/services/api/Order";
import { CreditCardData, PaymentMethod } from "./types";
export type { CreditCardData, PaymentMethod };

export const handleRemoveCartItem = async (itemId: string, t: TFunction) => {
  const isSuitcase = CURRENT_SUBDOMAIN === DEMANDORIA_SUBDOMAINS[2];

  const confirmMessage = t(
      isSuitcase
          ? "shoppingCart.alerts.removeItem_suitcase"
          : "shoppingCart.alerts.removeItem_cart"
  );

  if (confirm(confirmMessage)) {
    try {
      await cartItemApi.deleteCartItem(itemId);
    } catch (error) {
      console.error("Error removing cart item", error);
    }
  }
};

export const handleClearCartClick = async (cartId: string, t: TFunction) => {
  if (confirm(t("shoppingCart.alerts.clearCart"))) {
    try {
      await cartApi.deleteCart(cartId);
    } catch (error) {
      console.warn("Error cleaning items from cart: ", error);
    }
  }
};

export const handleRemoveAllCartItems = async (items: ICartItem[], t: TFunction) => {
  if (confirm(t("shoppingCart.alerts.clearCart"))) {
    try {
      await Promise.all(items.map((item) => cartItemApi.deleteCartItem(item.id)));
    } catch (error) {
      console.error("Error removing cart item", error);
    }
  }
};

const CARD_PAYMENT_METHODS: PaymentMethod[] = [
  "CREDIT_CARD",
  "CREDIT_CARD_EARLY_BUYER",
  "DEBIT_CARD",
];

export const handleCheckout = async (
    cartId: string,
    total: number,
    t: TFunction,
    paymentMethod: PaymentMethod,
    card: CreditCardData | null,
    onSuccess: (order: any) => void,
    onError: (msg: string) => void,
) => {
  try {
    const payload: any = {
      cartId,
      value: total,
      title: "Pedido via carrinho",
      installments: card?.totalParcelas,
      payment: {
        method: paymentMethod,
        softDescriptor: "Pedido",
      },
    };

    const doesPaymentMethodUseCard = CARD_PAYMENT_METHODS.includes(paymentMethod);

    if (doesPaymentMethodUseCard) {
      payload.payment.card = {
        holderName: card?.holderName,
        number: card?.number,
        expiration: card?.expiration,
        cvv: card?.cvv,
      };
    }

    const order = await orderApi.create(payload);

    if (paymentMethod !== "PIX") {
      await cartApi.finishCart(cartId);
    }

    onSuccess(order);
  } catch (error: any) {
    const msg =
        error?.response?.data?.message ||
        t("shoppingCart.alerts.paymentError");

    onError(msg);
  }
};